import React from "react";
import "./footer.css";

const footer = () => {
  return (
    <div className="footer-custom">
      <hr></hr>
      <h5>© 2024 - Justin Sykes</h5>
    </div>
  );
};

export default footer;
